import styled from "styled-components";

export const Input = styled("input")({
  display: "none",
});
